/**
 * Fase 2 (W33, item 5.6): mapa central do subtítulo de cada página, pela rota. Os textos ficam no i18n do núcleo
 * (`subtitulos.*`, em `i18n/subtitulos-<idioma>.ts`):
 *  - `/` → `subtitulos.inicio`;
 *  - `/conta/notificacoes` → `subtitulos.notificacoes` (a central de avisos tem página própria);
 *  - `/conta/<aba>` → `subtitulos.conta.<aba>` (sem aba, o Perfil);
 *  - `/<menu>/<módulo>/<aba>[/...]` → `subtitulos.paginas.<módulo>.<aba>`. A chave é do módulo dono e da aba, não do menu:
 *    a aba projetada em outro menu (Categorias do Financeiro em Cadastros) leva o mesmo texto, e a ficha aberta por baixo
 *    de uma aba também. Rota extra que não é aba (a ficha do parceiro) e a raiz do módulo (que redireciona) ficam sem.
 * O teste `tests/w33-paginas.test.ts` percorre todas as abas de todos os módulos e as rotas fora do menu.
 */
export function chaveSubtitulo(caminho: string): string | null {
  const partes = caminho.split('?')[0]!.split('/').filter(Boolean);
  if (partes.length === 0) return 'subtitulos.inicio';
  // B8: `/automacoes` sozinho leva ao painel do módulo (U7); as abas seguem a regra geral abaixo.
  if (partes[0] === 'automacoes' && partes.length === 1) return 'subtitulos.automacoes';
  // D1 (sub-sistemas): a tela inicial de escolha de empresa e sub-sistema.
  if (partes[0] === 'subsistemas' && partes.length === 1) return 'subtitulos.subsistemas';
  // FUN 2026-10-14 (cofre embutido): a página do link externo aberto dentro do MalgoOS.
  if (partes[0] === 'externo' && partes.length === 2) return 'subtitulos.externo';
  if (partes[0] === 'conta') {
    if (partes[1] === 'notificacoes') return 'subtitulos.notificacoes';
    return `subtitulos.conta.${partes[1] ?? 'perfil'}`;
  }
  if (partes.length < 3) return null;
  return `subtitulos.paginas.${partes[1]}.${partes[2]}`;
}
